var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-alert',{staticClass:"mb-2",attrs:{"message":_vm.alertMessage,"type":"info"}}),_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }